import { DatePicker } from '@ui-framework/index';
import dayjs from 'dayjs';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const EffectiveStartDate = forwardRef((props, ref) => {
  const { getValues } = useFormContext();
  const startDate = getValues(props?.name);

  const additionalProps = { disablePast: true };
  if (startDate) {
    if (dayjs(startDate).isBefore(new Date(), 'day')) {
      additionalProps.disablePast = true;
    } else {
      additionalProps.minDate = dayjs(startDate);
    }
  }

  return (
    <DatePicker ref={ref} name={props?.name} {...props} {...additionalProps} />
  );
});

export default EffectiveStartDate;
